import { useQuery } from '@tanstack/react-query';
import { ordersService } from '../services/orders.service';

export function useOrderTimeline(orderId: string) {
  return useQuery({
    queryKey: ['order-timeline', orderId],
    queryFn: () => ordersService.getOrderTimeline(orderId),
    enabled: !!orderId,
  });
}
